import React, { ReactElement } from "react";
import { Checkbox } from "@mui/material";
import inputsValidation from "../../messages/inputValidation";

interface IProps {
  name: string;
  field: object;
  title: ReactElement;
  description?: ReactElement;
  errors: any;
}

const CheckBoxInput: React.FC<IProps> = ({ field, name, title, description, errors }: IProps) => {
  return (
    <div className={"checkbox-div"} id={`checkbox-${name}`}>
      <p>
        <Checkbox {...field} className={"checkbox"} />
        {title}
      </p>
      {description && <p>{description}</p>}
      {errors[name] && (
        <span style={{ margin: "auto", width: "80%" }} className={"input-error"}>
          *{inputsValidation(errors, name)}
        </span>
      )}
    </div>
  );
};

export default CheckBoxInput;
